import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
import { Button, Grid, Icon, Progress, Text } from "~/components-shared";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
`;
const Content = styled(Grid)`
  width: 100%;
  ${_ref2 => {
  let {
    $maxWidth
  } = _ref2;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
  position: relative;
`;
const StyledProgress = styled(Progress)`
  position: absolute;
  top: 1.5rem;
  width: 100%;
  transform: translateY(-50%);
`;
const Item = styled.div`
  text-align: center;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
`;
const StyledButton = styled(Button)`
  width: 3rem;
  height: 3rem;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;
const Stepper = _ref3 => {
  let {
    s,
    activeValue,
    children,
    onChange = () => false,
    maxWidth,
    data = [],
    ...rest
  } = _ref3;
  const activeIndex = data.findIndex(item => item.id === activeValue);
  const progressValue = Math.round(100 / (data.length - 1) * activeIndex);
  const progressWidth = `${Math.round(100 / (data.length * 2) * (data.length * 2 - 2))}%`;
  const handleClick = id => {
    if (typeof onChange === "function") {
      onChange(id);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $s: s
  }, rest), /*#__PURE__*/React.createElement(Content, {
    cols: data.length,
    equal: true,
    justify: "center",
    $maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement(StyledProgress, {
    colors: ["primary"],
    values: [progressValue],
    height: 1,
    maxWidth: progressWidth
  }), data.map((item, index) => /*#__PURE__*/React.createElement(Stepper.Item, {
    onClick: () => handleClick(item.id),
    isActive: activeValue === item.id,
    isCompleted: activeIndex > index,
    key: item.id,
    label: item.id,
    value: item.value
  }, item.value))));
};
Stepper.Item = _ref4 => {
  let {
    isActive = false,
    isCompleted = false,
    value,
    label,
    children,
    ...rest
  } = _ref4;
  let color = "grey";
  if (isActive) {
    color = "primaryGrey";
  }
  if (isCompleted) {
    color = "primary";
  }
  return /*#__PURE__*/React.createElement(Item, rest, /*#__PURE__*/React.createElement(StyledButton, {
    color: isActive || isCompleted ? color : "white",
    $isActive: isActive,
    textAlign: "center",
    s: {
      mb: value ? 3 : 0
    },
    outline: true,
    rounded: true
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold",
    color: "inherit",
    fontSize: 4
  }, isCompleted ? /*#__PURE__*/React.createElement(Icon, {
    color: "inherit",
    scale: 5,
    src: "tick"
  }) : label)), children);
};
export default Stepper;